import React from 'react';

// Section title with a short gradient accent bar + thin divider line.
const SectionHeading = function({ id, isDark, children }) {
  return (
    <div className="mb-6">
      <h2 id={id} className={`text-base font-bold tracking-wider uppercase ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
        {children}
      </h2>
      <div className="mt-2.5 flex items-center gap-2">
        <span className="h-[3px] w-10 rounded-full bg-gradient-to-r from-blue-500 to-emerald-500" />
        <span className={`h-px flex-1 ${isDark ? 'bg-white/10' : 'bg-slate-200'}`} />
      </div>
    </div>
  );
}

export default SectionHeading;
